import { ApiProperty } from "@nestjs/swagger";
import { ProductInspectionSamplesDTO} from "./product-inspection-samples.dto";
export class ProductInspectionDTO{    
    
    @ApiProperty()
    inspectionId: number;

    @ApiProperty()
    date:Date

    @ApiProperty()
    section:string

    @ApiProperty()
    saleOrderId: number;

    @ApiProperty()
    saleOrderItemId: number;

    @ApiProperty()
    lotNumber:string

  
    @ApiProperty()
    isActive: boolean;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    versionFlag: number;

    @ApiProperty()
    samplesInfo : ProductInspectionSamplesDTO[]
}